module.exports = __webpack_public_path__ + "img/img_market_brand@3x.40b1568f.png";